import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import withDimensions from '../../hoc/withDimensions';
import { inlineStylesIfRanking } from '../../internal/helpers';
import { RankableTableBodyCell } from '../../styled/rankable/TableCell';
export var RankableTableCell = /*#__PURE__*/function (_React$Component) {
  _inherits(RankableTableCell, _React$Component);

  var _super = _createSuper(RankableTableCell);

  function RankableTableCell() {
    _classCallCheck(this, RankableTableCell);

    return _super.apply(this, arguments);
  }

  _createClass(RankableTableCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cell = _this$props.cell,
          head = _this$props.head,
          isFixedSize = _this$props.isFixedSize,
          isRanking = _this$props.isRanking,
          innerRef = _this$props.innerRef,
          refWidth = _this$props.refWidth;

      var content = cell.content,
          restCellProps = _objectWithoutProperties(cell, ["content"]);

      var _ref = head || {},
          shouldTruncate = _ref.shouldTruncate,
          width = _ref.width;

      var inlineStyles = inlineStylesIfRanking(isRanking, refWidth);
      return /*#__PURE__*/React.createElement(RankableTableBodyCell, _extends({}, restCellProps, {
        isFixedSize: isFixedSize,
        shouldTruncate: shouldTruncate,
        width: width,
        isRanking: isRanking,
        style: inlineStyles,
        innerRef: innerRef,
        onKeyDown: function onKeyDown(e) {
          return e.stopPropagation();
        }
      }), content);
    }
  }]);

  return RankableTableCell;
}(React.Component);
export default withDimensions(RankableTableCell);